import { usePage } from "@inertiajs/react";
import type { PropsWithChildren } from "react";

import AppBetaBanner from "@/components/app-beta-banner";
import { AppContent } from "@/components/app-content";
import { AppShell } from "@/components/app-shell";
import { AppSidebar } from "@/components/app-sidebar";
import { AppSidebarHeader } from "@/components/app-sidebar-header";
import type { SharedData } from "@/types";
import type { BreadcrumbItem } from "@/types";

export default function AppSidebarLayout({
  children,
  breadcrumbs = [],
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[];
}>) {
  const { show_beta_banner, banner_announcement } = usePage<SharedData>().props.ui ?? {};
  const showBanner = Boolean(show_beta_banner) || Boolean(banner_announcement);
  return (
    <AppShell variant="sidebar">
      <AppSidebar />
      <AppContent variant="sidebar" className="overflow-x-hidden">
        {showBanner && <AppBetaBanner />}
        <AppSidebarHeader breadcrumbs={breadcrumbs} />
        {children}
      </AppContent>
    </AppShell>
  );
}
